export default __webpack_public_path__ + "static/media/gp-mobile-landing-reseller.cf6b29ad.png";